const getValueOrEmptyString = value => value ?? "";

export default getValueOrEmptyString;
